// ==============================|| OVERRIDES - CHECKBOX ||============================== //

export default function Checkbox() {
	return {
		MuiCheckbox: {
			styleOverrides: {
				root: {
					color: '#1890ff',
					'&.Mui-checked': {
						color: '#4daa48',
					},
				},
			},
		},
	};
}
